import React from 'react';
import { UtilityPortalCredentialSection } from './index';
import { PendingCredentialFields } from './PendingCredentialFields';
import { UnsupportedProviderNotice } from './UnsupportedProviderNotice';

/**
 * The credential block, wherever a billing template is edited.
 *
 * Three modals render this. Keeping the staff gate in one place is the point: a fourth call site
 * that forgot it would offer the form to a customer.
 *
 * `propertyUtilityId` decides the mode. Present means a saved utility that can own a credential
 * now; absent means the utility does not exist yet, so the fields are collected and saved after
 * creation.
 */
export const UtilityCredentialSlot = _ref => {
  let isLivableStaff = _ref.isLivableStaff,
    isScraperSupportedProvider = _ref.isScraperSupportedProvider,
    className = _ref.className,
    companyId = _ref.companyId,
    propertyId = _ref.propertyId,
    propertyUtilityId = _ref.propertyUtilityId,
    utilityProviderId = _ref.utilityProviderId,
    utilityTypeId = _ref.utilityTypeId,
    providerName = _ref.providerName,
    credential = _ref.credential,
    onChanged = _ref.onChanged,
    pendingRef = _ref.pendingRef;
  if (!isLivableStaff) return null;
  if (!isScraperSupportedProvider) {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(UnsupportedProviderNotice, {
      providerName: providerName
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, propertyUtilityId ? /*#__PURE__*/React.createElement(UtilityPortalCredentialSection, {
    companyId: companyId,
    utilityProviderId: utilityProviderId,
    propertyId: propertyId,
    propertyUtilityId: propertyUtilityId,
    utilityTypeId: utilityTypeId,
    credential: credential,
    onChanged: onChanged
  }) : /*#__PURE__*/React.createElement(PendingCredentialFields, {
    dataRef: pendingRef,
    providerName: providerName
  }));
};